import * as React from 'react';

import IContainerElementProps from '../Interfaces/IContainerElementProps';

import handleRef from './handleRef';

const createContainerElement = <TElementAttributes,>({
    forwardedRef,
    elementAttributes,
    setFocusableElementRef,
    children,
}: IContainerElementProps<TElementAttributes>): React.ReactNode => (
    <div
        ref={handleRef.bind<null, typeof forwardedRef, typeof setFocusableElementRef, [HTMLDivElement], void>(
            null,
            forwardedRef,
            setFocusableElementRef
        )}
        {...elementAttributes}
    >
        {children}
    </div>
);

export default createContainerElement;
